import React, { useState, useMemo, useEffect } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

const DonutChart = ({ role, fileCounts }) => {
  const colorMap = {
    unsubmitted: "#f28e2c",
    inprocess: "#1b8cca",
    closed: "#59a150",
    running: "#f28e2c",
    complete: "#1b8cca",
  };

  const { series, labels, colors } = useMemo(() => {
    if (role === "employee") {
      const filtered =
        fileCounts?.filter((item) =>
          ["running", "complete"].includes(item.status)
        ) || [];
      return {
        series: filtered.map((item) => item.value),
        labels: filtered.map((item) => item.label),
        colors: filtered.map((item) => colorMap[item.status]),
      };
    } else {
      const filtered =
        fileCounts?.filter((item) =>
          ["unsubmitted", "inprocess", "closed"].includes(item.status)
        ) || [];
      return {
        series: filtered.map((item) => item.value),
        labels: filtered.map((item) => item.label),
        colors: filtered.map((item) => colorMap[item.status]),
      };
    }
  }, [role, fileCounts]);

  const total = series.reduce((a, b) => a + b, 0);
  const [centerValue, setCenterValue] = useState(total);
  const [centerLabel, setCenterLabel] = useState("Total Files");
  const userDetails = useSelector((state) => state?.user?.userDetails);

  const options = {
    chart: {
      type: "donut",
      // offsetY: 20,
      events: {
        dataPointMouseEnter: (event, chartContext, { dataPointIndex }) => {
          setCenterValue(series[dataPointIndex]);
          setCenterLabel(labels[dataPointIndex]);
        },
        dataPointMouseLeave: () => {
          setCenterValue(total);
          setCenterLabel("Total Files");
        },
      },
    },
    labels,
    colors,
    dataLabels: { enabled: false },
    legend: { position: "bottom", align: "start" },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
          labels: { show: false },
        },
      },
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
    stroke: { width: 0 },
  };

  useEffect(() => {
    setCenterValue(total);
    setCenterLabel("Total Files");
  }, [total]);

  // ✅ No data check before returning chart
  if (!series.length) {
    return (
      <div className="flex flex-col items-center justify-center text-gray-500 h-full">
        <img
          src="/assets/images/no_data.png"
          alt="no data"
          className="w-40 h-40 mb-3 opacity-70"
        />
        <p>No files found</p>
      </div>
    );
  }

  return (
    <div className="relative">
      <Chart
        options={options}
        series={series}
        type="donut"
        height={userDetails?.role === "employee" ? 300 : 280}
      />

      {/* Center overlay */}
      <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center pointer-events-none">
        <div className="text-[22px] font-bold">{centerValue}</div>
        <div className="text-[12px] text-gray-600">{centerLabel}</div>
      </div>
    </div>
  );
};

export default DonutChart;
